module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: ["dof-side-nav"],
    style: _vm.sideNavStyle
  }, [_c('scroller', [_c('div', {
    staticClass: ["list-box"]
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: ["item-box"],
      style: _vm.defaultItemStyle,
      on: {
        "click": function($event) {
          _vm.dofItemClick(item, index)
        }
      }
    }, [_c('text', {
      staticClass: ["item-text"],
      style: _vm.activeIndex == index ? _vm.activeTextStyle : _vm.defaultTextStyle
    }, [_vm._v(_vm._s(item))]), (_vm.activeIndex == index) ? _c('div', {
      staticClass: ["active-box"],
      style: _vm.activeBoxStyle
    }, [_c('div', {
      staticClass: ["line-box"],
      style: _vm.activeLineStyle
    })]) : _vm._e()])
  }))])])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-b18735f4!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-side-nav/index.vue
// module id = 658
// module chunks = 0 1